import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { withRouter } from "react-router-dom";
import { Container, Form, Row, Col } from "react-bootstrap";
import "./NormDetails.scss"
import messages from "../../assets/i18n";
import ButtonStandard from "../../components/ButtonStandard/ButtonStandard";
import { HeaderActions, FooterActions, LoadingSpinner, ToastMessage } from '../../components'
import { SIM, NAO } from '../../utils/constants';
import havePermissionTo from '../../utils/havePermission';

function NormDetails(props) {

	const dispatch = useDispatch();

	const lang = useSelector(state => state.language.name);
    const permissions = useSelector(state => state.authorization.permissions);

    const isloadingNormSave    = useSelector(state => state.producerDeclaration.isloadingNormSave);
	const isloadingNormDetails = useSelector(state => state.producerDeclaration.isloadingNormDetails);
    const selectedNorm         = useSelector(state => state.producerDeclaration.selectedNorm);
	const normDetails          = useSelector(state => state.producerDeclaration.normDetails);
    const loadNormDetails  = useSelector(state => state.producerDeclaration.loadNormDetails);

    const [isEdit, setIsEdit] = useState(false)
    const [disableSave, setDisableSave] = useState(true)
    const [disableSaveByPermission, setDisableSaveByPermission] = useState(true)

	const pageMessages = messages[lang].normDetailsPage
	const titlePage    = messages[lang].normDetailsPage.title;

    const normDetailsToast = useSelector(state => state.producerDeclaration.normDetailsToast);

    const [showToast, setShowToast]       = useState(false);    
    const [messageError, setMessageError] = useState('');
    const [messageType,  setMessageType]  = useState('toast-success');

	const pageBack = () => {
		props.history.push(`/norm-list`);
    };
    

    useEffect(() => {	
        setIsEdit(true)
        setDisableSave(false)
        dispatch({
            type: 'GET_NORM_DETAILS',
            id: loadNormDetails
        })        
        // eslint-disable-next-line react-hooks/exhaustive-deps
	}, [loadNormDetails]);

    useEffect(() => {	
        setShowToast(normDetailsToast.showToast)
        setMessageError(normDetailsToast.message)
        setMessageType(normDetailsToast.messageType)
        // eslint-disable-next-line react-hooks/exhaustive-deps
	}, [normDetailsToast]);

	useEffect(() => {
        if (havePermissionTo("edit-norm-details", permissions)) {
            setDisableSaveByPermission(false)
        }

        dispatch({
			type: 'SET_NORM_DETAILS_TOAST',
			payload: {
                showToast: false,
                message: "",
                messageType: "toast-success"
            }
		})

        if (selectedNorm) {
            setIsEdit(true)
            setDisableSave(false)
            dispatch({
                type: 'GET_NORM_DETAILS',
                id: selectedNorm
            })
        } else {
            dispatch({
                type: 'SET_NORM_DETAILS',
                payload: { ...normDetails, ativo: SIM }
            })
            setIsEdit(false)
            setDisableSave(true)
        }
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

    const updateFields = (fields) => {
        if (!fields.codigo || !fields.descricao) {
            setDisableSave(true)
        } else {
            setDisableSave(false)
        }

        dispatch({
            type: 'SET_NORM_DETAILS',
            payload: fields
        })
    };

    const saveNorm = () => {
        if (isEdit) {
            dispatch({
                type: 'UPDATE_NORM',
                payload: normDetails
            })
        } else {
            dispatch({
                type: 'CREATE_NORM',
                payload: normDetails
            })
        }
    }

	const saveButton = disabled => () =>
		<ButtonStandard
			id="norm_save_button"
			text={messages[lang].save}
			textClass="text-2"
			isLoading={isloadingNormSave}
			disabled={disabled}
			className="btn btn-primary btn-save btn-light"
			onClick={() => saveNorm()}
		/>;

	return (
		<div className="norm-details-page">
            <ToastMessage 
                show={showToast} 
                setShow={setShowToast}
                message={messageError} 
                toastClass={messageType} />
			<HeaderActions
				pageBack={pageBack}
				titlePage={titlePage}
			/>

			{
				isloadingNormDetails ?
				<div className="loader">
                    <LoadingSpinner />    
                </div> 
				:			
				<div>	
				<Container className="pt-3 justify-content-start">
					<Form className="px-3">
                        <Row>
                            <Form.Group as={Col} xs={6} className="mt-1">
                                <Form.Label className="text-2">{pageMessages.codigo}</Form.Label>

                                <Form.Control
                                    className="text-2 border-radius-full"
                                    type="text"
                                    defaultValue={isEdit && normDetails.codigo ? normDetails.codigo : ''}
                                    disabled={isloadingNormSave}
                                    onChange={event => updateFields(
                                        { ...normDetails, codigo: event.target.value },
                                    )}
                                    />

                            </Form.Group>

                            <Form.Group as={Col} xs={6} className="mt-1">
                                <Form.Label className="text-2">{pageMessages.descricao}</Form.Label>
                                
                                <Form.Control
                                    className="text-2 border-radius-full"
                                    type="text"
                                    defaultValue={isEdit && normDetails.descricao ? normDetails.descricao : ''}
                                    disabled={isloadingNormSave}
                                    onChange={event => updateFields(
                                        { ...normDetails, descricao: event.target.value },
                                    )}
                                    />
                            </Form.Group>	
                        </Row>

                        <Row>
                            <Form.Group as={Col} xs={6} className="mt-1">
                                <Form.Label className="text-2">{pageMessages.ativo}</Form.Label>

                                <div key={`inline-radio`} className="text-2">
                                    <div>
                                        <Form.Check
                                            inline
                                            label={messages[lang].yes}
                                            name="activeNormRadio"
                                            type="radio"
                                            defaultChecked={normDetails.ativo === SIM ? true : false}
                                            id={`inline-radio-1`}
                                            onChange={event => updateFields(
                                                { ...normDetails, ativo: SIM },
                                            )}
                                            disabled={isloadingNormSave}
                                        />
                                        <Form.Check
                                            inline
                                            label={messages[lang].no}
                                            name="activeNormRadio"
                                            type="radio"
                                            defaultChecked={normDetails.ativo === NAO ? true : false}
                                            id={`inline-radio-2`} 
                                            onChange={event => updateFields(
                                                { ...normDetails, ativo: NAO },
                                            )}
                                            disabled={isloadingNormSave}
                                        />
                                    </div>
                                </div>
                            </Form.Group>
                        </Row>
					</Form>
				</Container>
				</div>
			}
			<FooterActions
				ButtonGroupRight={saveButton(disableSave || disableSaveByPermission)}/>
		</div>
	)
}

export default withRouter(NormDetails);